import React from "react";
import { Alert, Grid, useTheme } from "@mui/material";
import PaymentReferenceItem from "../../dataitem/PaymentReferenceItem";
import ShadowBox from "../container/ShadowBox";
import dayjs from "dayjs";


const PersonPaymentReference = ({references, personId, mt = 6 }) => {
    const theme = useTheme();
    const referenceList = Object.keys(references).map((key) => references[key]).sort((a, b) => {
        if (Boolean(personId)) {
            if (a.personId === personId && b.personId !== personId) return -1;
            if (a.personId !== personId && b.personId === personId) return 1;
        }
        if (dayjs(a.timestamp).isAfter(dayjs(b.timestamp))) return -1;
        if (dayjs(a.timestamp).isBefore(dayjs(b.timestamp))) return 1;
        return 0;
    });

    return (
        <ShadowBox title="Referências Por Pagar" titleVariant="h3" mt={mt}>
            {
                referenceList.length === 0 ? (
                    <Alert sx={{ marginTop: theme.spacing(2) }} severity="info">Não existem referências de pagamento por pagar.</Alert>
                ) : (
                    <React.Fragment>
                        <Grid container spacing={theme.spacing(3)}>
                            {
                                referenceList.map((reference, index) => {
                                    return (
                                        <Grid item xs={12} sm={6} xl={4} key={index}>
                                            <PaymentReferenceItem reference={reference} />
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    </React.Fragment>
                )
            }
        </ShadowBox>
    )
}

export default PersonPaymentReference;
